import {
  Button,
  Card,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  makeStyles,
  Text,
  tokens
} from "@fluentui/react-components";
import { DismissFilled as Cancel, ArrowDownloadRegular, PersonRegular, StoreMicrosoftRegular } from "@fluentui/react-icons";
import React from 'react';
import { FormattedMessage } from "react-intl";
import { useNavigate } from 'react-router-dom';

import { useCommand } from "@tdp/core";


const useStyles = makeStyles({
  items: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingHorizontalM,
  },
  item: {
    display: "flex",
    flexDirection: "row",
    gap: tokens.spacingHorizontalL,
    padding: tokens.spacingHorizontalM,
    borderRadius: tokens.borderRadiusMedium,
    alignItems: "center",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingHorizontalXXS,
  }
})

export const DistributeDialog: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  appId: string | undefined;
}> = ({ isOpen, onClose, appId }) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const download = useCommand((commands) => commands.appListCommands.downloadApp);

  const CloseButton = () => (
    <Button appearance="transparent" icon={<Cancel />} onClick={onClose} />
  );
  const Item: React.FC<{ title: React.ReactNode; subtitle: React.ReactNode; icon: React.ReactNode; action: () => void }>
    = ({ title, subtitle, icon, action }) => (
      <Card className={styles.item} appearance="outline" onClick={action}>
        <div>
          {icon}
        </div>
        <div className={styles.title}>
          <Text weight="bold">{title}</Text>
          <Text>{subtitle}</Text>
        </div>
      </Card>
    );
  return (
    <Dialog open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle action={<CloseButton />}>
            <FormattedMessage defaultMessage="Distribute your app" />
          </DialogTitle>
          <DialogContent className={styles.items}>
            <Item
              icon={<ArrowDownloadRegular fontSize={36} />}
              title={<FormattedMessage defaultMessage="Download the app package" />}
              subtitle={<FormattedMessage defaultMessage="Download a copy of your app package, which is specific to your selected environment. Use the package to upload your app in Teams or publish later." />}
              action={() => { onClose(); appId && download(appId) }}
            />
            <Item
              icon={<PersonRegular fontSize={36} />}
              title={<FormattedMessage defaultMessage="Publish to your organisation" />}
              subtitle={<FormattedMessage defaultMessage="Submit a request to your IT admin to publish your app. It will appear in the Built for your org section of the store once it's approved." />}
              action={() => { onClose(); navigate(`/apps/${appId ?? ""}/publish-org`); }}

            />
            <Item
              icon={<StoreMicrosoftRegular fontSize={36} />}
              title={<FormattedMessage defaultMessage="Publish to the Teams Store" />}
              subtitle={<FormattedMessage defaultMessage="Make your app available to Teams users everywhere. This option requires Microsoft approval." />}
              action={() => { onClose(); navigate(`/apps/${appId ?? ""}/publish-store`); }}

            />
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
